type ThemeMode = 'light' | 'dark';

/**
 * Per-avatar hue palette. `dark` is the bright accent shown on the dark theme's
 * translucent tint; `light` is a darker variant of the same hue so the initials
 * stay readable when that tint composites over a white card — the bright accents
 * dropped to ~1.6:1 on light backgrounds.
 */
const AVATAR_HUES = [
  { bg: 'rgba(102,206,102,0.15)', dark: '#66ce66', light: '#1e7d32' },
  { bg: 'rgba(70,114,254,0.15)', dark: '#6b8efe', light: '#2f4fbf' },
  { bg: 'rgba(255,118,41,0.15)', dark: '#ff7629', light: '#8f4400' },
  { bg: 'rgba(190,94,200,0.15)', dark: '#be5ec8', light: '#7e3f99' },
  { bg: 'rgba(245,85,96,0.15)', dark: '#f55560', light: '#c0392b' },
] as const;

function toColor(hue: (typeof AVATAR_HUES)[number], mode: ThemeMode) {
  return { bg: hue.bg, text: mode === 'light' ? hue.light : hue.dark };
}

export function getAvatarColor(name: string, mode: ThemeMode = 'dark') {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return toColor(AVATAR_HUES[Math.abs(hash) % AVATAR_HUES.length], mode);
}

export function getAvatarColorById(id: number, mode: ThemeMode = 'dark') {
  return toColor(AVATAR_HUES[Math.abs(id) % AVATAR_HUES.length], mode);
}
